import { useContext } from "react"
import { Routes, Route } from "react-router-dom"
import { ServerRenderedProps } from "source/shared/contexts/ServerRenderedProps"
import { HardRefresh } from "source/shared/routingUtils"
import { DonationForm } from "./donation_form"
import { DonationThankYou } from "./donation_thank_you"
import { Profile } from "./profile"

export function Giving() {
  const { features } = useContext(ServerRenderedProps)

  const showDonationForm = features.monorepo_donation_form
  const showMyGiving = features.monorepo_my_giving

  if (!showDonationForm && !showMyGiving) {
    return <HardRefresh />
  }

  return (
    <Routes>
      <Route path="*" element={<HardRefresh />} />
      {showDonationForm && (
        <>
          <Route path="/" element={<DonationForm />} />
          <Route path="/donation_thank_you" element={<DonationThankYou />} />
        </>
      )}
      {showMyGiving && <Route path="/profile/*" element={<Profile />} />}
    </Routes>
  )
}
